import { Pledge, PledgeCampaign, GivingPerson } from "../types"
import { Fund } from "source/giving/donate/form/types"
import { Heading, Badge } from "@planningcenter/doxy-web"
import { formattedCents } from "source/giving/utils/money"
import { css } from "@emotion/react"
import PledgeProgressBar from "./PledgeProgressBar"
import { date } from "@churchcenter/datetime-fmt"
import { useGivingPersonContext } from "../hooks/useGivingPersonContext"

interface PledgeDetailsProps {
  jointGiver: GivingPerson | null
  pledge: Pledge
  pledgeCampaign: PledgeCampaign
  fund: Fund
  showFullDetails: boolean
}

export default function PledgeDetails({
  jointGiver,
  pledge,
  pledgeCampaign,
  fund,
  showFullDetails,
}: PledgeDetailsProps) {
  const { givingPerson } = useGivingPersonContext()
  const isConcluded = pledgeCampaign.ends_at
    ? new Date(pledgeCampaign.ends_at) < new Date()
    : false

  const campaignStartsAtDate = (() => {
    return date(pledgeCampaign.starts_at, {
      style: "standard",
      year: true,
    })
  })()

  const campaignEndsAtDate = (() => {
    return date(pledgeCampaign.ends_at, {
      style: "standard",
      year: true,
    })
  })()

  return (
    <div className="d-f fd-c g-2 action-drawer">
      <div>
        <div className="d-f jc-sb ai-c g-1">
          <Heading
            level={3}
            size={4}
            text={formattedCents(pledge.joint_amount_cents)}
            color="tint1"
          />
          <span className="d-b badge truncate">{fund.name}</span>
        </div>
        <div className="fs-13 fw-600 c-tint2 tt-u">
          {`To ${pledgeCampaign.name || "pledge campaign"}`}
        </div>
        {jointGiver && pledge.joint_giver_amount_cents && (
          <div className="fs-5 c-tint2">
            ({formattedCents(pledge.amount_cents)} by {givingPerson.first_name}{" "}
            {givingPerson.last_name} /{" "}
            {formattedCents(pledge.joint_giver_amount_cents)} by{" "}
            {jointGiver.first_name} {jointGiver.last_name})
          </div>
        )}
      </div>
      <PledgeProgressBar
        jointGiver={jointGiver}
        pledge={pledge}
        isConcluded={isConcluded}
      />
      {showFullDetails && (
        <div
          className="d-f fd-c g-1 p-1 br-8p"
          css={css`
            background-color: var(--color-tint6);
          `}
        >
          <dl className="d-f fd-c g-1">
            {pledgeCampaign.show_goal_in_church_center_app && (
              <div className="d-f jc-sb fd-c fd-r@sm">
                {" "}
                <dt className="fs-13 fw-500 c-tint1">Campaign progress</dt>
                <dd className="fs-5 ws-nw c-tint1">
                  {formattedCents(pledgeCampaign.received_total_cents || 0)} of{" "}
                  {formattedCents(pledgeCampaign.goal_cents || 0)} raised (
                  {pledgeCampaign.received_of_goal_percent || "0%"})
                </dd>
              </div>
            )}
            <div className="d-f jc-sb fd-c fd-r@sm">
              <dt className="fs-13 fw-500 c-tint1">Donation period</dt>
              <dd className="fs-5 ws-nw c-tint1">
                {campaignStartsAtDate} - {campaignEndsAtDate}
              </dd>
            </div>
          </dl>{" "}
        </div>
      )}
    </div>
  )
}
